<untrusted-link [href]="document | documentUrl" class="limit-text">
  <icon type="file-earmark-fill"></icon>
  {{ document.name }}
</untrusted-link>

@if (document.category_definition?.photo_type) {
<div class="photo-info">
  <div class="image">
    <img
      [src]="document | documentUrl : 'thumbnail'"
      [imageOverlay]="document | documentUrl"
      alt="thumbnail"
    />
  </div>
  @if (photoCategories != null) {
  <div>
    <div><strong>Categories:</strong></div>
    <span>{{ photoCategories }}</span>
  </div>
  }
</div>
}
